import { PAGE_TYPE } from '../constants';

export const getGraphQlReviewsOptions = ({ pageType, page, pageSize, storeId }) => {
  const OPTIONS = {
    filters: {
      ageRange: null,
      gender: null,
      isVerifiedPurchase: false,
      profile: null,
      prosCons: null,
      starRatings: null,
    },
    pagesize: pageSize.toString(),
    recfirstpage: pageSize.toString(),
    startIndex: 1,
    sortBy: 'photoreview',
    storeId
  };

  if (pageType === PAGE_TYPE.REVIEWS) {
    let startIndex = Math.max(((page || 1) - 1) * pageSize, 1);
    startIndex = page > 1 ? startIndex + 1 : startIndex;
    OPTIONS.startIndex = startIndex;
  }

  return {
    variables: {
      ...OPTIONS
    }
  };
};